import axios from "axios";

export default class UserService {
    create(model) {
        return axios
            .put("api/user/" + model.id, model);
    }
    update(model) {
        return axios
            .put("api/user/" + model.id, model);
    }
}
